import React from 'react'
import White from '../sections/white'
import { allIndustries } from '../../../jsons/allJsons'

const FoodAndBeverages = () => {
  return (
    <White data={allIndustries.food}/>
  )
}

export default FoodAndBeverages
